import Axios from '@/axios'

/*业务平台订阅*/

// 修改订阅关系：web:appSubscribe:change
export const AppSubscribeChange = data => {
  return Axios({
    url: '/device-manager/web-api/app-subscribe/change',
    method: 'POST',
    type: 'json',
    data
  })
}
// 查询订阅关系：web:appSubscribe:index
export const AppSubscribeIndex = data => {
  return Axios({
    url: '/device-manager/web-api/app-subscribe/index',
    method: 'POST',
    type: 'json',
    data
  })
}
